import { getShortName } from "./contributors";
import type { Prototype } from "./prototype-types";
import { abbyMillsPrototypes } from "./prototypes/abby-mills";
import { abhishekRaiPrototypes } from "./prototypes/abhishek-rai";
import { abigailWaterstonPrototypes } from "./prototypes/abigail-waterston";
import { ajaybirRatoulPrototypes } from "./prototypes/ajaybir-ratoul";
import { alexTsarapkinePrototypes } from "./prototypes/alex-tsarapkine";
import { alierHuPrototypes } from "./prototypes/alier-hu";
import { ammadShaikhPrototypes } from "./prototypes/ammad-shaikh";
import { amyJinPrototypes } from "./prototypes/amy-jin";
import { amyTalusPrototypes } from "./prototypes/amy-talus";
import { anatolyOstapenkoPrototypes } from "./prototypes/anatoly-ostapenko";
import { andrewLiuPrototypes } from "./prototypes/andrew-liu";
import { andyZhenPrototypes } from "./prototypes/andy-zhen";
import { aneleseWebskiPrototypes } from "./prototypes/anelese-webski";
import { arthurChePrototypes } from "./prototypes/arthur-che";
import { artyomGabtraupovPrototypes } from "./prototypes/artyom-gabtraupov";
import { austinDickPrototypes } from "./prototypes/austin-dick";
import { beccaSabnaniPrototypes } from "./prototypes/becca-sabnani";
import { bellaLuPrototypes } from "./prototypes/bella-lu";
import { benHamiltonPrototypes } from "./prototypes/ben-hamilton";
import { benjaminChaconPrototypes } from "./prototypes/benjamin-chacon";
import { brandonDangPrototypes } from "./prototypes/brandon-dang";
import { brianSolomonPrototypes } from "./prototypes/brian-solomon";
import { bronwynGemmillPrototypes } from "./prototypes/bronwyn-gemmill";
import { brooklynBrownPrototypes } from "./prototypes/brooklyn-brown";
import { carolynKaoPrototypes } from "./prototypes/carolyn-kao";
import { catWuPrototypes } from "./prototypes/cat-wu";
import { chanyeeKimPrototypes } from "./prototypes/chanyee-kim";
import { chrisChappellePrototypes } from "./prototypes/chris-chappelle";
import { chrisHandelPrototypes } from "./prototypes/chris-handel";
import { chrisRodriguezPrototypes } from "./prototypes/chris-rodriguez";
import { cristiWallacePrototypes } from "./prototypes/cristi-wallace";
import { emThompsonPrototypes } from "./prototypes/em-thompson";
import { emilyChenPrototypes } from "./prototypes/emily-chen";
import { erelGililovPrototypes } from "./prototypes/erel-gililov";
import { ericDingPrototypes } from "./prototypes/eric-ding";
import { etienneLamoureuxPrototypes } from "./prototypes/etienne-lamoureux";
import { fabioCarmoPrototypes } from "./prototypes/fabio-carmo";
import { gabeKelleyPrototypes } from "./prototypes/gabe-kelley";
import { gabrielaTeranPrototypes } from "./prototypes/gabriela-teran";
import { geoffBeresfordPrototypes } from "./prototypes/geoff-beresford";
import { haoyangDingPrototypes } from "./prototypes/haoyang-ding";
import { harshaYeddanapudyPrototypes } from "./prototypes/harsha-yeddanapudy";
import { harshdipSinghDeoganPrototypes } from "./prototypes/harshdip-singh-deogan";
import { henriquePovedanoPrototypes } from "./prototypes/henrique-povedano";
import { henryBullinghamPrototypes } from "./prototypes/henry-bullingham";
import { ireneLimbPrototypes } from "./prototypes/irene-limb";
import { ireneMaPrototypes } from "./prototypes/irene-ma";
import { jabranKhanPrototypes } from "./prototypes/jabran-khan";
import { jackGuoPrototypes } from "./prototypes/jack-guo";
import { jaiMankooPrototypes } from "./prototypes/jai-mankoo";
import { jamesBaoPrototypes } from "./prototypes/james-bao";
import { jasmineShenPrototypes } from "./prototypes/jasmine-shen";
import { jasmineZhangPrototypes } from "./prototypes/jasmine-zhang";
import { jasonHuPrototypes } from "./prototypes/jason-hu";
import { jeanYangPrototypes } from "./prototypes/jean-yang";
import { jeremyLeclercPrototypes } from "./prototypes/jeremy-leclerc";
import { jessBrownPrototypes } from "./prototypes/jess-brown";
import { jiaTuPrototypes } from "./prototypes/jia-tu";
import { jocelynTeresPrototypes } from "./prototypes/jocelyn-teres";
import { johnAdesidaPrototypes } from "./prototypes/john-adesida";
import { johnIntraterPrototypes } from "./prototypes/john-intrater";
import { justinLiPrototypes } from "./prototypes/justin-li";
import { kanikaAroraPrototypes } from "./prototypes/kanika-arora";
import { kasiaBedkowskiPrototypes } from "./prototypes/kasia-bedkowski";
import { katherineVidalPrototypes } from "./prototypes/katherine-vidal";
import { kellyVonZupPrototypes } from "./prototypes/kelly-von-zup";
import { kendraConnPrototypes } from "./prototypes/kendra-conn";
import { kevinBenscheidtPrototypes } from "./prototypes/kevin-benscheidt";
import { kevinChikPrototypes } from "./prototypes/kevin-chik";
import { kevinGengPrototypes } from "./prototypes/kevin-geng";
import { kevinLaiPrototypes } from "./prototypes/kevin-lai";
import { kevinLiPrototypes } from "./prototypes/kevin-li";
import { koroshAhangarPrototypes } from "./prototypes/korosh-ahangar";
import { kristinYehPrototypes } from "./prototypes/kristin-yeh";
import { lanLamPrototypes } from "./prototypes/lan-lam";
import { laurenBlakePrototypes } from "./prototypes/lauren-blake";
import { leighJenningsPrototypes } from "./prototypes/leigh-jennings";
import { leonKempersPrototypes } from "./prototypes/leon-kempers";
import { liamToranPrototypes } from "./prototypes/liam-toran";
import { maggieMurphyPrototypes } from "./prototypes/maggie-murphy";
import { marinaLiuPrototypes } from "./prototypes/marina-liu";
import { markWidishPrototypes } from "./prototypes/mark-widish";
import { martinSitarPrototypes } from "./prototypes/martin-sitar";
import { matthewBojeyPrototypes } from "./prototypes/matthew-bojey";
import { matthewLeandresPrototypes } from "./prototypes/matthew-leandres";
import { maxVanostrilloPrototypes } from "./prototypes/max-vanostrillo";
import { mehulPillaiPrototypes } from "./prototypes/mehul-pillai";
import { michaelYenPrototypes } from "./prototypes/michael-yen";
import { michaelZhangPrototypes } from "./prototypes/michael-zhang";
import { michalJezPrototypes } from "./prototypes/michal-jez";
import { mirandaFittsPrototypes } from "./prototypes/miranda-fitts";
import { nakulPathakPrototypes } from "./prototypes/nakul-pathak";
import { nickHowlandPrototypes } from "./prototypes/nick-howland";
import { nikitaTashchilinPrototypes } from "./prototypes/nikita-tashchilin";
import { oliviaOlearyPrototypes } from "./prototypes/olivia-oleary";
import { pauloPintoPrototypes } from "./prototypes/paulo-pinto";
import { pavloKuzhelPrototypes } from "./prototypes/pavlo-kuzhel";
import { pedroAlvesPrototypes } from "./prototypes/pedro-alves";
import { peiranHongPrototypes } from "./prototypes/peiran-hong";
import { poojaJumaniPrototypes } from "./prototypes/pooja-jumani";
import { quentinHsuPrototypes } from "./prototypes/quentin-hsu";
import { quinnBudanPrototypes } from "./prototypes/quinn-budan";
import { rannieTeodoroPrototypes } from "./prototypes/rannie-teodoro";
import { rebeccaGrayPrototypes } from "./prototypes/rebecca-gray";
import { remyGordonPrototypes } from "./prototypes/remy-gordon";
import { riyaPathakPrototypes } from "./prototypes/riya-pathak";
import { ryanLeePrototypes } from "./prototypes/ryan-lee";
import { sagarPatelPrototypes } from "./prototypes/sagar-patel";
import { samChiengPrototypes } from "./prototypes/sam-chieng";
import { samanthaYeePrototypes } from "./prototypes/samantha-yee";
import { sanjayRamanPrototypes } from "./prototypes/sanjay-raman";
import { sharonChanPrototypes } from "./prototypes/sharon-chan";
import { shengchaoWangPrototypes } from "./prototypes/shengchao-wang";
import { shilpaSubrahmanyamPrototypes } from "./prototypes/shilpa-subrahmanyam";
import { sophiaArriolaGibsonPrototypes } from "./prototypes/sophia-arriola-gibson";
import { sophieONeillLatulippePrototypes } from "./prototypes/sophie-o-neill-latulippe";
import { taneishaLugoPrototypes } from "./prototypes/taneisha-lugo";
import { tanyaMaPrototypes } from "./prototypes/tanya-ma";
import { taraRaoPanditPrototypes } from "./prototypes/tara-rao-pandit";
import { terenceDicksonPrototypes } from "./prototypes/terence-dickson";
import { timHooverPrototypes } from "./prototypes/tim-hoover";
import { tomFischerPrototypes } from "./prototypes/tom-fischer";
import { tomMaPrototypes } from "./prototypes/tom-ma";
import { tonyChenPrototypes } from "./prototypes/tony-chen";
import { trungNguyenPrototypes } from "./prototypes/trung-nguyen";
import { uzairAshrafPrototypes } from "./prototypes/uzair-ashraf";
import { vaibhavSinghPrototypes } from "./prototypes/vaibhav-singh";
import { varunAppaswamiPrototypes } from "./prototypes/varun-appaswami";
import { victoriaSchusterPrototypes } from "./prototypes/victoria-schuster";
import { vikasLalwaniPrototypes } from "./prototypes/vikas-lalwani";
import { wahabAhmadPrototypes } from "./prototypes/wahab-ahmad";
import { weiZhouPrototypes } from "./prototypes/wei-zhou";
import { willChartrandPrototypes } from "./prototypes/will-chartrand";
import { wyattHaymanPrototypes } from "./prototypes/wyatt-hayman";
import { yanwuGuPrototypes } from "./prototypes/yanwu-gu";
import { yaoWangPrototypes } from "./prototypes/yao-wang";
import { yikaiZhouPrototypes } from "./prototypes/yikai-zhou";
import { yukiMoPrototypes } from "./prototypes/yuki-mo";

export type { Prototype } from "./prototype-types";

const byLastUpdatedDesc = (a: Prototype, b: Prototype): number => {
  const byUpdated = b.lastUpdated.localeCompare(a.lastUpdated);
  if (byUpdated !== 0) return byUpdated;
  return b.createdAt.localeCompare(a.createdAt);
};

/** All feed prototypes, sorted newest-first by `lastUpdated` (then `createdAt`). */
export const prototypes: Prototype[] = [
  ...abbyMillsPrototypes,
  ...abhishekRaiPrototypes,
  ...abigailWaterstonPrototypes,
  ...ajaybirRatoulPrototypes,
  ...alexTsarapkinePrototypes,
  ...alierHuPrototypes,
  ...ammadShaikhPrototypes,
  ...amyJinPrototypes,
  ...amyTalusPrototypes,
  ...anatolyOstapenkoPrototypes,
  ...andrewLiuPrototypes,
  ...andyZhenPrototypes,
  ...aneleseWebskiPrototypes,
  ...arthurChePrototypes,
  ...artyomGabtraupovPrototypes,
  ...austinDickPrototypes,
  ...beccaSabnaniPrototypes,
  ...bellaLuPrototypes,
  ...benHamiltonPrototypes,
  ...benjaminChaconPrototypes,
  ...brandonDangPrototypes,
  ...brianSolomonPrototypes,
  ...bronwynGemmillPrototypes,
  ...brooklynBrownPrototypes,
  ...carolynKaoPrototypes,
  ...catWuPrototypes,
  ...chanyeeKimPrototypes,
  ...chrisChappellePrototypes,
  ...chrisHandelPrototypes,
  ...chrisRodriguezPrototypes,
  ...cristiWallacePrototypes,
  ...emThompsonPrototypes,
  ...emilyChenPrototypes,
  ...erelGililovPrototypes,
  ...ericDingPrototypes,
  ...etienneLamoureuxPrototypes,
  ...fabioCarmoPrototypes,
  ...gabeKelleyPrototypes,
  ...gabrielaTeranPrototypes,
  ...geoffBeresfordPrototypes,
  ...haoyangDingPrototypes,
  ...harshaYeddanapudyPrototypes,
  ...harshdipSinghDeoganPrototypes,
  ...henriquePovedanoPrototypes,
  ...henryBullinghamPrototypes,
  ...ireneLimbPrototypes,
  ...ireneMaPrototypes,
  ...jabranKhanPrototypes,
  ...jackGuoPrototypes,
  ...jaiMankooPrototypes,
  ...jamesBaoPrototypes,
  ...jasmineShenPrototypes,
  ...jasmineZhangPrototypes,
  ...jasonHuPrototypes,
  ...jeanYangPrototypes,
  ...jeremyLeclercPrototypes,
  ...jessBrownPrototypes,
  ...jiaTuPrototypes,
  ...jocelynTeresPrototypes,
  ...johnAdesidaPrototypes,
  ...johnIntraterPrototypes,
  ...justinLiPrototypes,
  ...kanikaAroraPrototypes,
  ...kasiaBedkowskiPrototypes,
  ...katherineVidalPrototypes,
  ...kellyVonZupPrototypes,
  ...kendraConnPrototypes,
  ...kevinBenscheidtPrototypes,
  ...kevinChikPrototypes,
  ...kevinGengPrototypes,
  ...kevinLaiPrototypes,
  ...kevinLiPrototypes,
  ...koroshAhangarPrototypes,
  ...kristinYehPrototypes,
  ...lanLamPrototypes,
  ...laurenBlakePrototypes,
  ...leighJenningsPrototypes,
  ...leonKempersPrototypes,
  ...liamToranPrototypes,
  ...maggieMurphyPrototypes,
  ...marinaLiuPrototypes,
  ...markWidishPrototypes,
  ...martinSitarPrototypes,
  ...matthewBojeyPrototypes,
  ...matthewLeandresPrototypes,
  ...maxVanostrilloPrototypes,
  ...mehulPillaiPrototypes,
  ...michaelYenPrototypes,
  ...michaelZhangPrototypes,
  ...michalJezPrototypes,
  ...mirandaFittsPrototypes,
  ...nakulPathakPrototypes,
  ...nickHowlandPrototypes,
  ...nikitaTashchilinPrototypes,
  ...oliviaOlearyPrototypes,
  ...pauloPintoPrototypes,
  ...pavloKuzhelPrototypes,
  ...pedroAlvesPrototypes,
  ...peiranHongPrototypes,
  ...poojaJumaniPrototypes,
  ...quentinHsuPrototypes,
  ...quinnBudanPrototypes,
  ...rannieTeodoroPrototypes,
  ...rebeccaGrayPrototypes,
  ...remyGordonPrototypes,
  ...riyaPathakPrototypes,
  ...ryanLeePrototypes,
  ...sagarPatelPrototypes,
  ...samChiengPrototypes,
  ...samanthaYeePrototypes,
  ...sanjayRamanPrototypes,
  ...sharonChanPrototypes,
  ...shengchaoWangPrototypes,
  ...shilpaSubrahmanyamPrototypes,
  ...sophiaArriolaGibsonPrototypes,
  ...sophieONeillLatulippePrototypes,
  ...taneishaLugoPrototypes,
  ...tanyaMaPrototypes,
  ...taraRaoPanditPrototypes,
  ...terenceDicksonPrototypes,
  ...timHooverPrototypes,
  ...tomFischerPrototypes,
  ...tomMaPrototypes,
  ...tonyChenPrototypes,
  ...trungNguyenPrototypes,
  ...uzairAshrafPrototypes,
  ...vaibhavSinghPrototypes,
  ...varunAppaswamiPrototypes,
  ...victoriaSchusterPrototypes,
  ...vikasLalwaniPrototypes,
  ...wahabAhmadPrototypes,
  ...weiZhouPrototypes,
  ...willChartrandPrototypes,
  ...wyattHaymanPrototypes,
  ...yanwuGuPrototypes,
  ...yaoWangPrototypes,
  ...yikaiZhouPrototypes,
  ...yukiMoPrototypes,
].sort(byLastUpdatedDesc);

// Helper functions to filter prototypes
export const getExperimentalPrototypes = (): Prototype[] =>
  prototypes.filter((p) => p.category === "experimental" && !p.hidden);

export const getTemplatePrototypes = (): Prototype[] =>
  prototypes.filter((p) => p.category === "template");

export const getPrototypesBySurface = (
  surfaceArea: "Brand" | "Retailer" | "Creative" | "Other"
): Prototype[] => prototypes.filter((p) => p.surfaceArea === surfaceArea);

export const getExperimentalBySurface = (
  surfaceArea: "Brand" | "Retailer" | "Creative" | "Other"
): Prototype[] =>
  prototypes.filter(
    (p) =>
      p.category === "experimental" &&
      p.surfaceArea === surfaceArea &&
      !p.hidden
  );

export const getTemplatesBySurface = (
  surfaceArea: "Brand" | "Retailer" | "Creative" | "Other"
): Prototype[] =>
  prototypes.filter(
    (p) => p.category === "template" && p.surfaceArea === surfaceArea
  );

// Project folder helpers
// Match owner by short name or full name so both conventions work
const ownerMatches = (protoOwner: string, queryOwner: string): boolean => {
  const a = getShortName(protoOwner).toLowerCase();
  const b = getShortName(queryOwner).toLowerCase();
  return a === b || protoOwner.toLowerCase() === queryOwner.toLowerCase();
};

export const getPrototypesByOwner = (owner: string): Prototype[] =>
  prototypes.filter((p) => ownerMatches(p.owner, owner) && !p.hidden);

export const getPrototypesByProject = (
  owner: string,
  project: string
): Prototype[] =>
  prototypes.filter(
    (p) =>
      ownerMatches(p.owner, owner) &&
      p.project?.toLowerCase() === project.toLowerCase() &&
      !p.hidden
  );

export const getUngroupedPrototypes = (owner: string): Prototype[] =>
  prototypes.filter(
    (p) => ownerMatches(p.owner, owner) && !p.project && !p.hidden
  );

export const getProjectsForOwner = (owner: string): string[] => {
  const ownerPrototypes = getPrototypesByOwner(owner);
  const projects = ownerPrototypes
    .filter((p) => p.project)
    .map((p) => p.project as string);
  return Array.from(new Set(projects));
};
